import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { DateTime } from 'scaleflow/utils/date-time';
import textDeltaIsEmpty from 'scaleflow/utils/text-delta-is-empty';

export default class BusinessGoalsGoalController extends Controller {
  @service betaToggle;
  @service router;
  @service intl;

  queryParams = ['originUrl'];

  @tracked showDeleteModal = false;
  @tracked selectedGoal = null;
  @tracked summaryPanelIsOpen = true;
  @tracked originUrl;

  get leftPanelColSpan() {
    return this.summaryPanelIsOpen ? 'col-span-8' : 'col-span-11';
  }

  textDeltaIsEmpty = textDeltaIsEmpty;

  @action
  deleteMetric() {}

  @action
  toggleDeleteModal(flag) {
    if (flag === undefined) this.showDeleteModal = !this.showDeleteModal;
    else this.showDeleteModal = flag;
  }

  @action
  confirmDeleteGoal() {
    this.selectedGoal = this.model;
    this.toggleDeleteModal(true);
  }

  @action
  deleteGoal() {
    if (this.selectedGoal) {
      this.selectedGoal.destroyRecord().then(() => {
        this.handleDismissDeleteModal();
        this.goToListPage();
      });
    }
  }

  @action
  setGoalStatus(status) {
    this.model.active = status.value;
    this.model.save();
  }

  @action
  unselectGoal() {
    this.selectedGoal = null;
  }

  @action
  handleDismissDeleteModal() {
    this.unselectGoal();
    this.toggleDeleteModal(false);
  }

  @action
  goToListPage() {
    this.router.transitionTo('business.goals.list');
  }

  @action
  deleteTarget({ content: metric }) {
    const target = metric.targetForGoal(this.model.id);
    target?.destroyRecord?.();
  }

  @action
  statusClass(metric) {
    if (!metric) return;
    const target = metric.targetForGoal(this.model.id);
    const measurement = metric?.latestMeasurement?.value ?? 0;
    const isTargetAchieved =
      measurement >= target.target_value &&
      DateTime.from(measurement.measured_at_utc).isSameOrBefore(
        target.target_date,
      );
    if (isTargetAchieved) return 'ring ring-green-600';
    else return 'ring ring-red-400';
  }

  @action
  toggleSummaryPanel() {
    this.summaryPanelIsOpen = !this.summaryPanelIsOpen;
  }

  @action
  goToGoal(e) {
    const currentRouteName = this.router.currentRoute.name;
    this.router.transitionTo(currentRouteName, e.value);
  }

  get tabs() {
    const tabs = [
      {
        label: this.intl.t('dictionary.description'),
        route: 'business.goals.goal.description',
        key: 'description',
      },
      {
        label: this.intl.t('_initiatives.title', { num: 2 }),
        route: 'business.goals.goal.initiatives',
        key: 'initiatives',
      },
      {
        label: this.intl.t('_goals.sub-goals'),
        route: 'business.goals.goal.subgoals',
        key: 'subgoals',
      },
      {
        label: this.intl.t('dictionary.metrics', { num: 2 }),
        route: 'business.goals.goal.metrics',
        key: 'metrics',
        hide: !this.betaToggle.showMetrics,
      },
    ];
    return tabs;
  }

  @action
  isActive(tab) {
    return this.router.currentRouteName.includes(tab.key);
  }
}
